import { useContext } from "react";
import FactoryContext from "../../contexts/factoryContext";
import useLeagueSeason from "./useLeagueSeason";
import useUserInfo from "./useUserInfo";

/**
 *
 * @returns {?Team}
 */
export default function useUserTeam() {
  const factory = useContext(FactoryContext);
  const { userInfo } = useUserInfo();
  const { leagueSeason } = useLeagueSeason();

  const loaded = userInfo && userInfo.hasLoaded() && leagueSeason;

  let team = null;

  const getUserTeamFromLeagueSeason = (leagueSeason) => {
    const teamsInLeagueSeason = Object.keys(userInfo.data.teams)
      .map((teamId) => userInfo.data.teams[teamId])
      .filter((team) => team.leagueSeason === leagueSeason.obj.id);

    if (teamsInLeagueSeason.length === 0) return null;

    if (teamsInLeagueSeason.length > 1) {
      // sort by user role
      teamsInLeagueSeason.sort((a, b) => {
        const username = userInfo.data.user.username;
        if (a.roles[username].value === b.roles[username].value) return 0;
        return a.roles[username].value < b.roles[username].value ? -1 : 1;
      });
    }

    return teamsInLeagueSeason[0];
  };

  if (loaded) {
    let teamObj;
    const selectedTeamId = userInfo.data.user.selectedTeam;
    if (selectedTeamId) {
      if (userInfo.data.teams[selectedTeamId]) {
        teamObj = userInfo.data.teams[selectedTeamId];
        if (teamObj.leagueSeason !== leagueSeason.obj.id) {
          // get user team from leagueSeason
          teamObj = getUserTeamFromLeagueSeason(leagueSeason);
        }
      } else {
        console.error(
          `user does not have team that matches selected team: ${selectedTeamId}`
        );
      }
    } else {
      // get userTeam from leagueSeason
      teamObj = getUserTeamFromLeagueSeason(leagueSeason);
    }

    if (teamObj) {
      team = factory.makeTeam(teamObj);
    }
  }

  return team;
}
